import { api } from './api';

const list = (proposal_id) => {
  return api({method: 'GET', url: process.env.REACT_APP_API_URL+'/'+proposal_id+'/qpr'});
}

const basicInformation = (qpr_id) => {
  return api({method: 'GET', url: process.env.REACT_APP_API_URL+'/qpr/'+qpr_id+'/basic-information'});
}

const basicInformationSave = (input, qpr_id) => {
  return api({method: 'POST', url: process.env.REACT_APP_API_URL+'/qpr/'+qpr_id+'/basic-information'}, input);
}

const researchBackground = (qpr_id) => {
  return api({method: 'GET', url: process.env.REACT_APP_API_URL+'/qpr/'+qpr_id+'/research-background'});
}

const researchBackgroundSave = (input, qpr_id) => {
  return api({method: 'POST', url: process.env.REACT_APP_API_URL+'/qpr/'+qpr_id+'/research-background'}, input);
}

const responseToTE = (qpr_id) => {
  return api({method: 'GET', url: process.env.REACT_APP_API_URL+'/qpr/'+qpr_id+'/response-to-te'});
}

const responseToTESave = (input, qpr_id) => {
  return api({method: 'POST', url: process.env.REACT_APP_API_URL+'/qpr/'+qpr_id+'/response-to-te'}, input);
}

const progressReport = (qpr_id) => {
  return api({method: 'GET', url: process.env.REACT_APP_API_URL+'/qpr/'+qpr_id+'/progress-report'});
}

const progressReportSave = (input, qpr_id) => {
  return api({method: 'POST', url: process.env.REACT_APP_API_URL+'/qpr/'+qpr_id+'/progress-report'}, input);
}

const progressPPT = (qpr_id) => {
  return api({method: 'GET', url: process.env.REACT_APP_API_URL+'/qpr/'+qpr_id+'/progress-ppt'});
}

const progressPPTSave = (input, qpr_id) => {
  return api({method: 'POST', url: process.env.REACT_APP_API_URL+'/qpr/'+qpr_id+'/progress-ppt'}, input);
}

const progressPPTDelete = (qpr_id, pp_id) => {
  return api({method: 'DELETE', url: process.env.REACT_APP_API_URL+'/qpr/'+qpr_id+'/progress-ppt/'+pp_id});
}
const planForRemainingQuarter = (qpr_id) => {
  return api({method: 'GET', url: process.env.REACT_APP_API_URL+'/qpr/'+qpr_id+'/plan-for-remaining-quarter'});
}

const planForRemainingQuarterSave = (input, qpr_id) => {
  return api({method: 'POST', url: process.env.REACT_APP_API_URL+'/qpr/'+qpr_id+'/plan-for-remaining-quarter'}, input);
}

const projectGanttChart = (qpr_id) => {
  return api({method: 'GET', url: process.env.REACT_APP_API_URL+'/qpr/'+qpr_id+'/project-gantt-chart'});
}

const projectGanttChartSave = (input, qpr_id) => {
  return api({method: 'POST', url: process.env.REACT_APP_API_URL+'/qpr/'+qpr_id+'/project-gantt-chart'}, input);
}

const projectGanttChartDelete = (qpr_id, pgc_id) => {
  return api({method: 'DELETE', url: process.env.REACT_APP_API_URL+'/qpr/'+qpr_id+'/project-gantt-chart/'+pgc_id});
}

const submit = (input, qpr_id) => {
  return api({method: 'POST', url: process.env.REACT_APP_API_URL+'/qpr/'+qpr_id+'/submit'}, input);
}

const utilizationCertificate = (qpr_id) => {
  return api({method: 'GET', url: process.env.REACT_APP_API_URL+'/qpr/'+qpr_id+'/utilization-certificate'});
}

const utilizationCertificateSave = (input, qpr_id) => {
  return api({method: 'POST', url: process.env.REACT_APP_API_URL+'/qpr/'+qpr_id+'/utilization-certificate'}, input);
}

const utilizationCertificateDelete = (qpr_id) => {
  return api({method: 'DELETE', url: process.env.REACT_APP_API_URL+'/qpr/'+qpr_id+'/utilization-certificate/'});
}

const te = (qpr_id) => {
  return api({method: 'GET', url: process.env.REACT_APP_API_URL+'/qpr/'+qpr_id+'/te'});
}

const log = (qpr_id) => {
  return api({method: 'GET', url: process.env.REACT_APP_API_URL+'/qpr/'+qpr_id+'/log'});
}

export const qprService = {
  list,
  basicInformation,
  basicInformationSave,
  researchBackground,
  researchBackgroundSave,
  responseToTE,
  responseToTESave,
  progressReport,
  progressReportSave,
  progressPPT,
  progressPPTSave,
  progressPPTDelete,
  planForRemainingQuarter,
  planForRemainingQuarterSave,
  projectGanttChart,
  projectGanttChartSave,
  projectGanttChartDelete,
  submit,
  utilizationCertificate,
  utilizationCertificateSave,
  utilizationCertificateDelete,
  te,
  log
};